import React from 'react';
import { FiLinkedin, FiTwitter, FiFacebook } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Footer = () => {
  return (
    <footer className="bg-navy border-t border-cyan/20 pt-16 pb-8 relative overflow-hidden">
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-px bg-gradient-to-r from-transparent via-cyan to-transparent opacity-50"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          
          <div>
            <a href="#home" className="font-heading text-2xl font-bold tracking-wider flex items-center gap-2 mb-6">
              <span className="text-white">Vitro</span>
              <span className="text-cyan text-glow">techworld</span>
            </a>
            <p className="text-slate-400 text-sm leading-relaxed mb-6">
              A next-generation technology company specializing in AI, ML, Electrification, Hydrogen Fuel Cells, Autonomous Vehicles, and Software Development.
            </p>
          </div>

          <div className="md:px-8">
            <h4 className="text-white font-heading font-bold mb-6 text-lg">Quick Links</h4>
            <ul className="space-y-3">
              {['Company', 'Technology', 'Careers', 'News', 'Contact Us'].map((item) => (
                <li key={item}>
                  <a href={`#${item.toLowerCase().replace(' ', '')}`} className="text-slate-400 hover:text-cyan transition-colors text-sm flex items-center gap-2">
                    <span className="w-1 h-1 bg-cyan rounded-full"></span>
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-heading font-bold mb-6 text-lg">Contact Info</h4>
            <ul className="space-y-4 text-slate-400 text-sm">
              <li className="flex items-start gap-3">
                <span className="text-cyan mt-1">📍</span>
                <span>Vitro Globe Travel World, Unit no. 317 Tower B4, Spaze I-Tech Park, Sector 49, Sohna Road, Gurgaon, Haryana 122018</span>
              </li>
              <li className="flex items-center gap-3">
                <span className="text-cyan">📞</span>
                <span>+91 8624876371</span>
              </li>
              <li className="flex items-center gap-3">
                <span className="text-cyan">✉️</span>
                <span>Vitroglobeind@gmail.com</span>
              </li>
            </ul>
            <div className="flex gap-4 mt-6">
              {[FiLinkedin, FiTwitter, FiFacebook].map((Icon, idx) => (
                <a key={idx} href="#" className="w-10 h-10 rounded-full bg-charcoal border border-cyan/20 flex items-center justify-center text-cyan hover:bg-cyan hover:text-navy transition-all">
                  <SafeIcon icon={Icon} />
                </a>
              ))}
            </div>
          </div>

        </div>

        <div className="border-t border-white/5 pt-8 mt-8 text-center flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            &copy; 2025 Vitrotechworld. All Rights Reserved.
          </p>
          <div className="text-slate-500 text-sm space-x-4">
            <a href="#" className="hover:text-cyan transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-cyan transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;